import { intelligentPhotoCaptureConstants } from '../constants';
export const INTELLIGENT_PHOTO_CAPTURE_ESTIMATOR_GALLERY_IMAGE_DELETE = `${intelligentPhotoCaptureConstants.MODULE_PREFIX}_ESTIMATOR_GALLERY_IMAGE_DELETE`;
export const INTELLIGENT_PHOTO_CAPTURE_ESTIMATOR_GALLERY_IMAGE_REPLACEMENT = `${intelligentPhotoCaptureConstants.MODULE_PREFIX}_ESTIMATOR_GALLERY_IMAGE_REPLACEMENT`;
export const INTELLIGENT_PHOTO_CAPTURE_ESTIMATOR_GALLERY_RESET = `${intelligentPhotoCaptureConstants.MODULE_PREFIX}_ESTIMATOR_GALLERY_RESET`;
export const photoCaptureIntelligentEstimatorGalleryImageDeleteAction = (galleryAttachments) => ({
    type: INTELLIGENT_PHOTO_CAPTURE_ESTIMATOR_GALLERY_IMAGE_DELETE,
    payload: { galleryAttachments }
});
export const photoCaptureIntelligentEstimatorGalleryImageReplacementAction = (galleryAttachments) => ({
    type: INTELLIGENT_PHOTO_CAPTURE_ESTIMATOR_GALLERY_IMAGE_REPLACEMENT,
    payload: { galleryAttachments }
});
export const photoCaptureIntelligentEstimatorGalleryResetAction = () => ({
    type: INTELLIGENT_PHOTO_CAPTURE_ESTIMATOR_GALLERY_RESET,
    payload: null
});
//# sourceMappingURL=photoCaptureIntelligentEstimatorThumbnailGalleryActions.js.map